/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import styled from "styled-components";

const StyledTreeChild = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-inline: 1.5rem 0.5rem;
  min-width: 0;

  ${({ theme }) => theme.containerMedia.sm} {
    padding-inline: 1.5rem 0;
  }

  ${({ $isLast, theme }) =>
    !$isLast && `
      &::before {
        left: 10px;
        content: "";
        background: rgb(${theme.colors.border.rgb});
        top: -4px;
        width: 2px;
        height: calc(100% + 8px);
        position: absolute;
      }
    `
  }

  &::after {
    left: 10px;
    content: "";
    background: transparent;
    top: -5px;
    width: 10px;
    height: calc(100% - 4px);
    position: absolute;
    border-bottom-left-radius: 6px;
    border: 2px solid rgb(${({ theme }) => theme.colors.border.rgb});
    border-top: none;
    border-right: none;
  }
`;

const TreeChild = ({ children, isLast, actions, ...props }) => {
  return <StyledTreeChild isLast={isLast} {...props}>{children}</StyledTreeChild>;
};

export default TreeChild;
